// Centrální konstanty aplikace
// Přidej sem nový stav nebo typ — projeví se automaticky všude.

// ─── Typy trenažérů ────────────────────────────────────────────────────────

export const MACHINE_TYPES = [
  { value: 'TR3',         label: 'Autom TR3',         shortLabel: 'TR3' },
  { value: 'TR4',         label: 'Autom TR4',         shortLabel: 'TR4' },
  { value: 'TR3 (1. sk.)', label: 'Autom TR3 (1. sk.)', shortLabel: 'TR3 (1. sk.)' },
  { value: 'TR4 (1. sk.)', label: 'Autom TR4 (1. sk.)', shortLabel: 'TR4 (1. sk.)' },
  { value: 'PC', label: 'PC', shortLabel: 'PC' },
];

// Barvy badgí pro typy trenažérů (použito v Templates.jsx)
export const MACHINE_TYPE_COLORS = {
  'TR3':         { bg: '#E3F2FD', color: '#1565C0' },
  'TR4':         { bg: '#F3E5F5', color: '#6A1B9A' },
  'TR3 (1. sk.)': { bg: '#E0F2F1', color: '#00695C' },
  'TR4 (1. sk.)': { bg: '#FFF3E0', color: '#E65100' },
  'PC': { bg: '#E8F5E9', color: '#2E7D32' },
};

// ─── Stavy trenažérů ───────────────────────────────────────────────────────

export const MACHINE_STATUSES = [
  { value: 'nahled',      label: 'Náhled',      bg: '#FFF8E1', color: '#FF8F00' },
  { value: 'ceka_na_schvaleni', label: 'Čeká na schválení', bg: '#E8EAF6', color: '#283593' },
  { value: 'neobjednano', label: 'Neobjednáno', bg: '#F5F5F5', color: '#666666' },
  { value: 'objednano',   label: 'Objednáno',   bg: '#E3F2FD', color: '#1976D2' },
  { value: 've_vyrobe',   label: 'Ve výrobě',   bg: '#FFF3E0', color: '#F57C00' },
  { value: 'pripraveno',  label: 'Připraveno',  bg: '#F3E5F5', color: '#7B1FA2' },
  { value: 'doruceno',    label: 'Doručeno',    bg: '#E8F5E9', color: '#388E3C' },
];

// Pomocné mapy odvozené ze MACHINE_STATUSES — nepřidávej ručně, edituj pole výše
export const MACHINE_STATUS_LABELS = Object.fromEntries(
  MACHINE_STATUSES.map(s => [s.value, s.label])
);

export const MACHINE_STATUS_COLORS = Object.fromEntries(
  MACHINE_STATUSES.map(s => [s.value, { bg: s.bg, color: s.color }])
);

// Výchozí stav pro nový trenažér
export const DEFAULT_MACHINE_STATUS = 'neobjednano';
export const DEFAULT_MACHINE_TYPE   = 'TR3';
